export default __webpack_public_path__ + "static/media/img-splice-3.a51c10e8.png";